import DOMPurify from "dompurify";
import React, { useRef } from "react";
import { useState } from "react";

export function ProductAccordion({label,content,useAsHTML}:{label:string,content:string,useAsHTML:boolean}){



    const [isOpen,setIsOpen] = useState(false);
    const contentRef = useRef<HTMLDivElement>(null);
    return <div className={"v-accordion "+(isOpen?"toggled-on":"") }>
    <div onClick={()=>setIsOpen(!isOpen)} className=" flex-row justify-between align-center accordion-label" style={{fontSize:"16px",fontWeight:"600",padding:"18px 0px",borderBottom:"1px solid #cdcdcd"}}>
        <span>{label}</span>
   
        <AccordionMinus/>
  
    </div>
    <div className="accordion-content" style={(isOpen&&contentRef.current?{maxHeight:contentRef.current.clientHeight+100}:{})} >
       {useAsHTML?
        <div ref={contentRef} style={{padding:"12px 0px 24px 0px"}} dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(content)}}>
       
        </div>:
        <div ref={contentRef} style={{padding:"12px 0px 24px 0px"}}>{content}</div>
        }
    </div>
    </div>

}

function AccordionMinus(){
    return <div className="accordion-caret center-all plus-minus " style={{fontSize:"18px"}} >
      <svg className="first" fill="currentColor" height="1em"  xmlns="http://www.w3.org/2000/svg" style={{position:"absolute",transform:"rotateZ(90deg)"}} viewBox="0 0 448 512"><path d="M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z"/></svg>
      <svg className="second" fill="currentColor" height="1em" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z"/></svg>
    </div>
  }